module.exports = __webpack_public_path__ + "img/wuwow-loading.2263a6e3.svg";